// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"779":"catalog-frontend-vendors","965":"host"}[chunkId] + "." + {"779":"8ae98cf8","965":"8c088676"}[chunkId] + ".min.css";
};